"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = exports.requestInitialStateNew = exports.initialStatusSSE = exports.requestInitialState = void 0;
const types_1 = require("./types");
exports.requestInitialState = {
    loading: false,
    error: null,
    refreshLoading: false,
    loaded: false,
};
exports.initialStatusSSE = {
    error: null,
    type: types_1.EEventMessageSSEType.CLOSED,
};
exports.requestInitialStateNew = {
    loading: undefined,
    error: null,
    refreshLoading: false,
};
var ErrorType;
(function (ErrorType) {
    ErrorType[ErrorType["RESPONSE_ERROR"] = 1] = "RESPONSE_ERROR";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
//# sourceMappingURL=index.js.map